import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GenesysSupportCenterController } from '@ori/support-center';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { SupportCenterRoot } from '~/components';
import { Layout } from '~/containers/Layout';
const SupportCenterContainer = dynamic(async ()=>(await import(/* webpackChunkName: "SupportCenter_SupportCenterContainer" */ '@ori/support-center')).SupportCenterContainer, {
    loadableGenerated: {
        webpack: ()=>[
                require.resolveWeak("@ori/support-center")
            ]
    },
    ssr: false,
    loading: ()=>null
});
const SupportCenterPage = (param)=>{
    let { layoutPage, enableGenesysSupportCentre, hideWebMessenger, staticStorageUrl } = param;
    return enableGenesysSupportCentre ? /*#__PURE__*/ _jsx(Layout, {
        layoutPage: layoutPage,
        children: /*#__PURE__*/ _jsx(GenesysSupportCenterController, {
            hideWebMessenger: hideWebMessenger
        })
    }) : /*#__PURE__*/ _jsx(SupportCenterRoot, {
        children: /*#__PURE__*/ _jsxs(Layout, {
            layoutPage: layoutPage,
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        /*#__PURE__*/ _jsx("link", {
                            rel: "preload",
                            as: "style",
                            crossOrigin: "anonymous",
                            href: "".concat(staticStorageUrl, "/icons/v4/legacy/icons.css")
                        }),
                        /*#__PURE__*/ _jsx("link", {
                            rel: "stylesheet",
                            crossOrigin: "anonymous",
                            href: "".concat(staticStorageUrl, "/icons/v4/legacy/icons.css"),
                            media: "all"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SupportCenterContainer, {})
            ]
        })
    });
};
export var __N_SSG = true;
export default SupportCenterPage;
